import React from 'react';
import CustomInput from '../../components/CustomInput';

import { BoxInput, TitleInput } from './input.styles';

const Input = ({ title, margin, onChange, ...props }) => {
    return (
      <BoxInput style={{ margin }}>
        {title && <TitleInput>{title}</TitleInput>}
        <CustomInput onChange={onChange} {...props} />
      </BoxInput>
    );
};

export default Input;